"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableState = void 0;
class ObservableState {
    constructor(initialState) {
        this.observers = [];
        this.state = initialState;
    }
    getState() {
        return this.state;
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
    }
    removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
    updateState(newState) {
        this.state = Object.assign(Object.assign({}, this.state), newState);
        this.notifyObservers();
    }
    notifyObservers() {
        for (const observer of this.observers) {
            observer(this.state);
        }
    }
}
exports.ObservableState = ObservableState;
